/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PurchaseCreditsResponse = zod
	.object({
		edit_id: zod.uuid().describe('Metronome contract edit ID'),
		status: zod.string().describe('Purchase status (submitted)')
	})
	.describe('Credit purchase result');

export type PurchaseCreditsResponse = zod.input<typeof PurchaseCreditsResponse>;
export type PurchaseCreditsResponseOutput = zod.output<typeof PurchaseCreditsResponse>;
